import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  containerClass?: string;
}
export function Section({
  id,
  className = '',
  children,
  containerClass = ''
}: SectionProps) {
  return <section id={id} className={`py-20 lg:py-32 ${className}`} data-id="element-348">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7
    }} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${containerClass}`} data-id="element-349">
        {children}
      </motion.div>
    </section>;
}